import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function CalendarSchedule(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(
    SvgIcon,
    {
      ...rest,
      "data-tidal": "TidalIllustration",
      "data-tidal-illustration": "CalendarSchedule",
      sx,
      viewBox,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M6 17.74h36v20.347a3.13 3.13 0 0 1-3.13 3.13H9.13A3.13 3.13 0 0 1 6 38.087V17.74Z",
            fill: theme.vars.palette.primary.light
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M9.13 9.913h29.74a3.13 3.13 0 0 1 3.13 3.13v4.696H6v-4.696a3.13 3.13 0 0 1 3.13-3.13Z",
            fill: theme.vars.palette.primary.light
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M17.738 6h-1.565c-.865 0-1.566.7-1.566 1.565v4.696c0 .864.701 1.565 1.566 1.565h1.565c.864 0 1.565-.7 1.565-1.565V7.565c0-.864-.7-1.565-1.565-1.565Zm14.089 0H30.26c-.864 0-1.565.7-1.565 1.565v4.696c0 .864.701 1.565 1.566 1.565h1.565c.864 0 1.565-.7 1.565-1.565V7.565c0-.864-.7-1.565-1.565-1.565Z",
            fill: theme.vars.palette.primary.light
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M24.001 38.087a8.609 8.609 0 1 0 0-17.217 8.609 8.609 0 0 0 0 17.217Z",
            fill: theme.vars.palette.primary.dark
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M28.697 30.26h-5.478V24a.782.782 0 1 1 1.565 0v4.695h3.913a.782.782 0 1 1 0 1.565ZM42 17.74H6v1.565h36v-1.566Z",
            fill: theme.vars.palette.secondary.main
          }
        )
      ]
    }
  );
}
CalendarSchedule.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "CalendarSchedule"
};
validateTidalLicense();
export {
  CalendarSchedule
};
//# sourceMappingURL=CalendarSchedule.js.map
